class UnitsEdit {
  constructor(data = {}) {
    this.idUnidad = data.idUnidad || 0;
    this.vin = data.vin || "";
    this.chasis = data.chasis || "";
    this.anio = data.anio || "";
    this.estatus = data.estatus || true;
    this.idUbicacion = data.idUbicacion || 0;
    this.ubicacion = data.ubicacion || "";
    this.idUbicacionDestino = data.idUbicacionDestino || 0;
    this.ubicacionDestino = data.ubicacionDestino || "";
    this.idCliente = data.idCliente || 0;
    this.cliente = data.cliente || "";
    this.idMarca = data.idMarca || 0;
    this.marca = data.marca || "";
    this.idModelo = data.idModelo || 0;
    this.modelo = data.modelo || "";
    this.fechaRegistro = data.fechaRegistro || "";
    this.idUsuario = data.idUsuario || "";
  }
}

class UnitsAdd {
  constructor(data = {}) {
    this.idUnidad = data.idUnidad || 0;
    this.vin = data.vin || "";
    this.chasis = data.chasis || "";
    this.anio = data.anio || "";
    this.estatus = data.estatus || true;
    this.idUbicacion = data.idUbicacion || 0;
    this.ubicacion = data.ubicacion || "";
    this.idUbicacionDestino = data.idUbicacionDestino || 0;
    this.ubicacionDestino = data.ubicacionDestino || "";
    this.idCliente = data.idCliente || 0;
    this.cliente = data.cliente || "";
    this.idMarca = data.idMarca || 0;
    this.marca = data.marca || "";
    this.idModelo = data.idModelo || 0;
    this.modelo = data.modelo || "";
    this.fechaRegistro = data.fechaRegistro || "";
  }
}

export { UnitsEdit, UnitsAdd };
